import React, { useEffect } from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.css";
import "magnific-popup";
// import logo from "../images/background/image13.png";
// import logo1 from "../images/image1.png";

// COMPONENTS
import { Link } from "react-router-dom";
import { Navbar, Footer, Footer2,Services, Projects, About, Home, Contact, Navbar2} from "../components";
import Helmet from "react-helmet";
import { getRouteMeta } from "../seoData";

// IMAGES

const MainPage = () => {
  const { title, description: desc, image, url } = getRouteMeta("/");
  return (
    <div className="" id="">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} data-react-helmet="true"></meta>

        <meta property="og:type" content="website" data-react-helmet="true"></meta>
        <meta property="og:url" content={url} data-react-helmet="true"></meta>
        <meta property="og:title" content={title} data-react-helmet="true"></meta>
        <meta property="og:description" content={desc} data-react-helmet="true"></meta>
        <meta property="og:image" content={image} data-react-helmet="true"></meta>

        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:url" content={url} data-react-helmet="true"></meta>
        <meta property="twitter:title" content={title} data-react-helmet="true"></meta>
        <meta property="twitter:description" content={desc} data-react-helmet="true"></meta>
        <meta property="twitter:image" content={image} data-react-helmet="true"></meta>
      </Helmet>
      <Navbar2/>
      <Home/>
      {/* <Services/> */}
      {/* <Projects/> */}
      {/* <About/> */}
      {/* <Contact/> */}
      {/* <Footer2 id=""/> */}
      {/* <Footer/> */}
    </div>
  );
};

export default MainPage;
